import { ExternalLink } from '../types/ExternalLink';
import { Link } from '../types/Link';

export const isExternalLink = (link: Link): link is ExternalLink => {
  return link.kind === 'external';
};
